import { Container } from '@chakra-ui/react';
import { FC } from 'react';

import { AboutAuthorsPanel } from '@/components/ui/features/lecture/AboutAuthorsPanel/AboutAuthorsPanel';
import { LearnMorePanel } from '@/components/ui/features/lecture/LearnMorePanel/LearnMorePanel';
import { LectureAbstract } from '@/components/ui/features/lecture/LectureAbstract/LectureAbstract';
import {
  LectureGrid,
  LectureGridContent,
  LectureGridDownloads,
  LectureGridSidebar,
  LectureGridSpeakers,
  LectureGridTabs,
  LectureGridSuggestions,
} from '@/components/ui/features/lecture/LectureContentSection/LectureContentSection.elements';
import { LectureDiscussion } from '@/components/ui/features/lecture/LectureDiscussion/LectureDiscussion';
import { LectureDownloads } from '@/components/ui/features/lecture/LectureDownloads/LectureDownloads';
import { LectureSpeakers } from '@/components/ui/features/lecture/LectureSpeakers/LectureSpeakers';
import { LectureSuggestions } from '@/components/ui/features/lecture/LectureSuggestions/LectureSuggestions';
import { LectureTabs } from '@/components/ui/features/lecture/LectureTabs/LectureTabs';

export const LectureContentSection: FC = () => {
  return (
    <Container pt={{ base: 12, md: 6 }}>
      <LectureGrid>
        <LectureGridContent>
          <LectureSpeakers as={LectureGridSpeakers} />
          <LectureTabs
            as={LectureGridTabs}
            discussion={<LectureDiscussion />}
            abstract={<LectureAbstract />}
            aboutAuthors={<AboutAuthorsPanel />}
            learnMore={<LearnMorePanel />}
          />
        </LectureGridContent>

        <LectureGridSidebar>
          <LectureDownloads as={LectureGridDownloads} />
          <LectureSuggestions as={LectureGridSuggestions} />
        </LectureGridSidebar>
      </LectureGrid>
    </Container>
  );
};
